// @flow
import React, {Component} from 'react';
import {StyleSheet, View} from 'react-native';
import {Text} from 'trpc-react-native-ui';
import Icon from '../../components/common/Icon';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';
import Contacts from '../../components/profile/Contacts';
import BillingAddress from '../../components/profile/BillingAddress.container';
import ProfileItemsPickerButton from './components/ProfileItemsPickerButton';
import * as Navigation from '../../lib/navigation.js';

export type FlaggedProps = {
  canEditBillingAddress: boolean,
  canChangeContactNumber: boolean,
  canChangeMarketingApproval: boolean,
  canChangeLanguage: boolean,
  env: 'dev' | 'stage' | 'prod',
};

type StateProps = {
  customer: Object,
  hasBillingAddress: boolean,
};

type Props = StateProps & FlaggedProps;

class Profile extends Component<Props> {
  goToChangeBillingAddress = () => Navigation.navigate('changeBillingAddress');
  goToChangePassword = () => Navigation.navigate('changePassword');
  goToLanguageSelector = () => Navigation.navigate('languageSelector');
  goToChangeContactNumber = () => Navigation.navigate('changeContactNumber');
  goToChangeMarketingApproval = () =>
    Navigation.navigate('changeMarketingApproval');
  goToDeleteAccount = () => Navigation.navigate('deleteAccount');

  render() {
    const {
      customer,
      hasBillingAddress,
      canEditBillingAddress,
      canChangeContactNumber,
      canChangeMarketingApproval,
      canChangeLanguage,
      env,
    } = this.props;

    if (!customer) return null;
    return (
      <View style={styles.container}>
        <View style={styles.section}>
          <Icon name="user-circle" size={50} style={styles.icon} />
          <View style={styles.sectionContent}>
            <Text style={styles.sectionTitle}>{customer.fullName}</Text>
            <Text>{customer.email}</Text>
            {customer.contactNumber || customer.contactEmail ? (
              <Contacts customer={customer} />
            ) : null}
          </View>
        </View>
        {hasBillingAddress && canEditBillingAddress && (
          <ProfileItemsPickerButton
            first
            onPress={this.goToChangeBillingAddress}>
            <View>
              <Text style={[styles.label]}>{I18n.t('billingAddress')}</Text>
              <BillingAddress />
            </View>
          </ProfileItemsPickerButton>
        )}
        <ProfileItemsPickerButton
          label={I18n.t('password')}
          value="************"
          onPress={this.goToChangePassword}
        />
        {(env === 'dev' || canChangeLanguage) && (
          <ProfileItemsPickerButton
            label={I18n.t('language')}
            value={I18n.t('currentLanguage')}
            onPress={this.goToLanguageSelector}
          />
        )}
        {canChangeContactNumber && (
          <ProfileItemsPickerButton
            label={I18n.t('Dashboard.ChangeContactNumber.contactNumber')}
            value={customer.contactNumber}
            onPress={this.goToChangeContactNumber}
          />
        )}
        {canChangeMarketingApproval && (
          <ProfileItemsPickerButton
            label={I18n.t('Dashboard.MarketingApproval.marketingApproval')}
            onPress={this.goToChangeMarketingApproval}
          />
        )}
        {
          <ProfileItemsPickerButton
            label={I18n.t('Dashboard.DeleteAccount.deleteAccount')}
            onPress={this.goToDeleteAccount}
          />
        }
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    backgroundColor: theme.backgroundColor,
  },
  innerContainer: {
    alignItems: 'stretch',
  },
  section: {
    padding: 10,
    flexDirection: 'row',
  },
  sectionContent: {
    paddingVertical: 5,
    paddingHorizontal: 10,
  },
  sectionTitle: {
    fontWeight: '500',
    fontSize: 16,
  },
  inlineField: {
    flexDirection: 'row',
  },
  label: {
    fontSize: 14,
    fontWeight: '600',
    marginRight: 5,
  },
  icon: {
    color: theme.profile.iconColor,
  },
  editIcon: {
    padding: 5,
  },
});

export default Profile;
